import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TableSkeletonComponent } from '@dss-libs/shared/ui/common-components';
import { TTableSkeletonColumn } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'juno-libs-ui-transaction-history-skeleton',
  imports: [TableSkeletonComponent],
  templateUrl: './transaction-history-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionHistorySkeletonComponent {
  readonly tableColumns: TTableSkeletonColumn[] = [
    { minWidth: '21rem', lines: ['h-4 w-64'] },
    { minWidth: '14rem', lines: ['h-4 w-36'] },
    { minWidth: '9rem', lines: ['h-4 w-20'] },
    { cellClass: 'flex-none w-16 justify-center', lines: ['h-8 w-8 rounded-full -ms-5'] },
  ];
}
